import React, { useState } from "react";
import { languageHelper } from "../../config/helperFunctions";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

function CategoryButton({ category, handleSelectCategory, handleIsSubCat }) {
  const now = new Date();
  const timeString =
    now.getHours().toString().padStart(2, "0") +
    ":" +
    now.getMinutes().toString().padStart(2, "0") +
    ":" +
    now.getSeconds().toString().padStart(2, "0");

  const isTimeInRange = (current, start, end) => {
    if (!start || !end) return false;

    const toSeconds = (timeStr) => {
      const [h, m, s] = timeStr.split(":").map(Number);
      return h * 3600 + m * 60 + s;
    };

    const currentSec = toSeconds(current);
    const startSec = toSeconds(start);
    const endSec = toSeconds(end);

    if (startSec <= endSec) {
      // Normal same-day range
      return currentSec >= startSec && currentSec <= endSec;
    } else {
      // Overnight range
      return currentSec >= startSec || currentSec <= endSec;
    }
  };

  const isEnabled = category?.category_schedule
    ? isTimeInRange(
        timeString,
        category.category_schedule?.start_time,
        category.category_schedule?.end_time
      )
    : true;

  return (
    <button
      className={`w-36 h-fit text-nowrap text-d-bg-text py-4 px-2 text-xl bg-[#f0f5f9] hover:bg-d-bg hover:text-white transition-colors overflow-clip moving-item-name ${
        !isEnabled && "opacity-50 cursor-not-allowed"
      }`}
      disabled={!isEnabled}
      onClick={() => {
        handleSelectCategory(category);
        handleIsSubCat(false);
      }}
    >
      <p className="">
        {defaultLang === "text_en"
          ? category.category_name
          : category.cat_name_arabic}
      </p>
    </button>
  );
}

function SubCategoryButton({
  subCategory,
  handleSelectCategory,
  handleIsSubCat,
}) {
  return (
    <button
      className="w-36 h-fit text-nowrap text-d-bg-text py-4 px-2 text-xl bg-[#f0f5f9] hover:bg-d-bg hover:text-white transition-colors overflow-x-clip moving-item-name"
      onClick={() => {
        handleSelectCategory(subCategory);
        handleIsSubCat(true);
      }}
    >
      <p>
        {defaultLang === "text_en"
          ? subCategory.sub_category_name
          : subCategory.sub_category_name_arabic}
      </p>
    </button>
  );
}

function FoodMenuButton({
  foodMenu,
  handleItemSelect,
  selectedPaymentMethod,
  selectedPaymentCompany,
  currency,
  customerId
}) {
  const foodMenuPrice =
    selectedPaymentMethod === 6
      ? foodMenu.delivery_companies.find(
          (company) => company.delivery_company_id === selectedPaymentCompany
        )?.sale_price || foodMenu.sale_price
      : foodMenu.sale_price;

  const isDiscount =
    foodMenu?.discount?.[0]?.specific_customers === "yes"
      ? foodMenu?.discount?.[0]?.multi_customer_id?.some(
          (id) => String(id) === String(customerId)
        )
      : Boolean(foodMenu?.discount?.[0]?.discount_amount);

  const isOffer =
    foodMenu?.offers?.[0]?.specific_customers === "yes"
      ? foodMenu?.offers?.[0]?.multi_customer_id?.some(
          (id) => String(id) === String(customerId)
        )
      : Boolean(foodMenu?.offers?.[0]);

  return (
    <button
      className="w-36 h-fill text-d-bg-text text-xl bg-[#f0f5f9] overflow-x-clip flex flex-col"
      onClick={() => handleItemSelect(foodMenu)}
      disabled={foodMenu.out_of_stock}
    >
      <div className="cursor-pointer">
        <h1 className="py-1 text-white text-md font-bold text-center bg-d-bg relative">
          {currency || "S.R"} {foodMenuPrice}
          {isDiscount && (
            <span className="bg-yellow-400 absolute -top-2.5 left-0 px-2 rounded-full text-sm font-normal">{`${
              foodMenu.discount[0]?.discount_amount
            }${
              foodMenu.discount[0]?.dis_type === "amount" ? currency || "S.R" : "%"
            }`}</span>
          )}
          {isOffer && foodMenu?.offers?.[0] && (
            <span className="bg-emerald-600 text-white absolute -top-2.5 right-0 px-2 rounded-full text-xs font-semibold shadow">
              {(foodMenu.offers[0].offer_type === "group" || foodMenu.offers[0].offer_type === "category") ? `${languageHelper("Mix")} ${foodMenu.offers[0].buy}+${foodMenu.offers[0].free} ${languageHelper("Free")}` : `${languageHelper("Buy")} ${foodMenu.offers[0].buy}+${foodMenu.offers[0].free} ${languageHelper("Free")}`}
            </span>
          )}
        </h1>
        <img
          className="w-32 h-32 mx-auto my-1"
          src={
            foodMenu.photo
              ? foodMenu.photo_url
              : "/assets/items/image_thumb.png"
          }
          alt=""
        />
        {foodMenu.out_of_stock && (
          <h2 className="py-1 text-sm font-bold text-center text-white bg-d-bg [text-shadow:1px_1px_0_var(--tw-color-d-bg-text),-1px_-1px_0_var(--tw-color-d-bg-text),1px_-1px_0_var(--tw-color-d-bg-text),-1px_1px_0_var(--tw-color-d-bg-text)]">
            {languageHelper("Out of stock")}
          </h2>
        )}
        <span className="">
          <p
            className="py-1 px-1 text-md font-bold text-center cursor-pointer"
          >
            {defaultLang === "text_en" ? foodMenu.name : foodMenu.name_arabic}
          </p>
        </span>
      </div>
    </button>
  );
}

function POSCategory(props) {
  const categories = props.categories;
  const subCategories = props.subCategories;
  const foodMenus = props.foodMenus;
  const currency = props.currency;
  const customerId = props.customerId;

  const [selectedSubCategory, setSelectedSubCategory] = useState([]);
  const [selectedFoodMenu, setSelectedFoodMenu] = useState([]);
  const [selectedType, setSelectedType] = useState("category");

  const handleSelectCategory = (category) => {
    if (category.is_sub_cat === 0) {
      setSelectedFoodMenu(
        foodMenus.filter((foodMenu) => foodMenu.category_id === category.id)
      );
      setSelectedType("foodMenu");
    } else {
      setSelectedSubCategory(
        subCategories.filter(
          (subCategory) => subCategory.category_id === category.id
        )
      );
      setSelectedType("subCat");
    }
  };

  const handleSelectSubCat = (subCat) => {
    setSelectedFoodMenu(
      foodMenus.filter((foodMenu) => foodMenu.sub_category_id === subCat.id)
    );
    setSelectedType("foodMenu");
  };

  const handleSearch = (e) => {
    if (e.target.value === "") {
      setSelectedType("category");
      return;
    }
    const searchValue = e.target.value.toLowerCase();
    setSelectedType("foodMenu");

    const filteredMenus = foodMenus.filter((menu) =>
      menu.name.toLowerCase().includes(searchValue)
    );

    setSelectedFoodMenu(filteredMenus);
  };

  return (
    <div className="my-8 bg-white rounded-md p-1 lg:max-h-[85vh] h-screen lg:h-full overflow-auto">
      <div className="flex items-center gap-x-2 bg-[#f0f5f9] rounded-xl px-2 text-xs">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="14"
          width="14"
          viewBox="0 0 512 512"
        >
          <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
        </svg>
        <input
          className="w-full bg-transparent py-2 focus:outline-none"
          placeholder="Search product name"
          type="text"
          onChange={handleSearch}
          name=""
          id=""
        />
      </div>
      <div className="flex gap-2">
        {props.isSubCat && (
          <button
            onClick={() => {
              setSelectedType("subCat");
              props.handleIsSubCat(false);
            }}
            className="bg-d-cat-btn px-4 py-1 text-white rounded-lg my-2"
          >
            {languageHelper("Back")}
          </button>
        )}
        <button
          onClick={() => {
            setSelectedType("category");
            props.handleIsSubCat(false);
          }}
          className="bg-d-cat-btn px-4 py-1 text-white rounded-lg my-2"
        >
          {languageHelper("All Category")}
        </button>
      </div>
      <div
        className={`flex gap-1 flex-wrap ${
          selectedType === "foodMenu" && "justify-start"
        } overflow-y-auto py-4 max-h-[65vh]`}
      >
        {selectedType === "category"
          ? categories.map((category, index) => (
              <CategoryButton
                key={index}
                category={category}
                handleSelectCategory={handleSelectCategory}
                handleIsSubCat={props.handleIsSubCat}
              />
            ))
          : selectedType === "subCat"
          ? selectedSubCategory.map((subCategory, index) => (
              <SubCategoryButton
                key={index}
                subCategory={subCategory}
                handleSelectCategory={handleSelectSubCat}
                handleIsSubCat={props.handleIsSubCat}
              />
            ))
          : selectedFoodMenu.map((foodMenu, index) => (
              <FoodMenuButton
                key={index}
                foodMenu={foodMenu}
                handleItemSelect={props.handleItemSelect}
                selectedPaymentMethod={props.selectedPaymentMethod}
                selectedPaymentCompany={props.selectedPaymentCompany}
                currency={currency}
                customerId={customerId}
              />
            ))}
      </div>
    </div>
  );
}

export default POSCategory;
